module.exports = __webpack_public_path__ + "img/aboutusTW.bc026be9.png";